<template>
<div class="chapter">
<div class="inner_page">
<p class="ackhd2">HAPPY CREATING</p>
<p class="ack"><span class="grey">I dedicate this book to all of my students, both past and present. Thank you for giving me this opportunity to share my knowledge with you. May you always find the time to enjoy the creative adventure.</span></p>
<p class="fig"><img alt="image" src="images/pg3-1.jpg"/></p>
<blockquote class="Caption">One-Hour Flower</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Fm_happy.vue?250afc32